import { jsx as _jsx } from "react/jsx-runtime";
import CheckboxIcon from '../../../icons/components/checkbox-icon';
import UncheckBoxIcon from '../../../icons/components/unchecked-icon';
import IndeterminateCheckboxIcon from '../../../icons/components/indeterminate-checkbox-icon';
// ----------------------------------------------------------------------
export function checkbox(theme) {
    return {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(1),
                    '&.Mui-disabled': {
                        color: theme.palette.action.disabled,
                        opacity: 0.5,
                        cursor: 'not-allowed'
                    }
                }
            },
            defaultProps: {
                icon: _jsx(UncheckBoxIcon, {}),
                checkedIcon: _jsx(CheckboxIcon, {}),
                indeterminateIcon: _jsx(IndeterminateCheckboxIcon, {})
            }
        }
    };
}
